// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Background overlay */
.popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

/* Centered Modal */
.popup-center-modal {
    background: #fff;
    width: 500px; /* Adjust size */
    max-width: 90%;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    animation: fadeInScale 0.3s ease-in-out;
}

/* Header */
.popup-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 24px;
    background-color: #f5f5f5;
    border-bottom: 1px solid #ddd;
}

/* Title */
.popup-title {
    margin: 0;
    font-size: 22px;
    font-weight: 600;
}

/* Close button */
.popup-close {
    background: none;
    border: none;
    font-size: 26px;
    cursor: pointer;
    color: #333;
    position: absolute;
    right: 10px;
    top: 155px;
    transition: color 0.3s ease;
}

/* Modal body */
.popup-body {
    padding: 24px;
    max-height: 70vh;
    overflow-y: auto;
}

/* Fade and scale animation */
@keyframes fadeInScale {
    from {
        opacity: 0;
        transform: scale(0.9);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/home/PopupModal.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA,mBAAmB;AACnB;IACI,gBAAgB;IAChB,YAAY,EAAE,gBAAgB;IAC9B,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,yCAAyC;IACzC,uCAAuC;AAC3C;;AAEA,WAAW;AACX;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA,UAAU;AACV;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA,iBAAiB;AACjB;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,2BAA2B;AAC/B;;AAEA,eAAe;AACf;IACI,aAAa;IACb,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,6BAA6B;AAC7B;IACI;QACI,UAAU;QACV,qBAAqB;IACzB;IACA;QACI,UAAU;QACV,mBAAmB;IACvB;AACJ","sourcesContent":["/* Background overlay */\n.popup-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.4);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 9999;\n}\n\n/* Centered Modal */\n.popup-center-modal {\n    background: #fff;\n    width: 500px; /* Adjust size */\n    max-width: 90%;\n    border-radius: 10px;\n    overflow: hidden;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n    animation: fadeInScale 0.3s ease-in-out;\n}\n\n/* Header */\n.popup-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 16px 24px;\n    background-color: #f5f5f5;\n    border-bottom: 1px solid #ddd;\n}\n\n/* Title */\n.popup-title {\n    margin: 0;\n    font-size: 22px;\n    font-weight: 600;\n}\n\n/* Close button */\n.popup-close {\n    background: none;\n    border: none;\n    font-size: 26px;\n    cursor: pointer;\n    color: #333;\n    position: absolute;\n    right: 10px;\n    top: 155px;\n    transition: color 0.3s ease;\n}\n\n/* Modal body */\n.popup-body {\n    padding: 24px;\n    max-height: 70vh;\n    overflow-y: auto;\n}\n\n/* Fade and scale animation */\n@keyframes fadeInScale {\n    from {\n        opacity: 0;\n        transform: scale(0.9);\n    }\n    to {\n        opacity: 1;\n        transform: scale(1);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
